import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/autoplay";
import { EffectCoverflow, Autoplay, Pagination } from "swiper/modules";
import { Link, useNavigate } from 'react-router-dom';
import Nav from "../components/Nav";
import { Footer } from '../components/footer';
import { Upperbox } from '../components/Upperbox';
import img4 from "../images/c9.jpg";
import img3 from "../images/c8.jpg";
import img5 from "../images/c7.jpg";
import img6 from "../images/c6.jpg";
import img7 from "../images/c5.jpg";
import img8 from "../images/c4.jpg";
import img9 from "../images/c3.jpg";
import img10 from "../images/c2.jpg";
import img11 from "../images/c1.jpg";
import img12 from "../images/c.jpg";

import './Grababitenow.css';
import './Portfoliomain.css';

export const Grababitenow = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/Contactus');
  };

  return (
    <div>
      <Upperbox />
      <Nav />

      <div className='business-page'>
        <div className='business-content-container'>
          <h1 className='business-section-title'>
          Here Are Our Chef's Specials – Finest creations at Sri Krishnaa Authentic Indian Cuisine!
          </h1>

          {/* Integrated Swiper (MySwiper) Code */}
          <div className="port-sec">
            <div className="collection">
            <Swiper
  effect="coverflow"
  grabCursor={true}
  centeredSlides={true}
  loop={true}
  slidesPerView={window.innerWidth < 768 ? 1 : "auto"}  // 1 slide on mobile, auto on larger screens
  spaceBetween={10} // Adds spacing between slides for better visibility
  modules={[EffectCoverflow, Autoplay, Pagination]}
  coverflowEffect={{
    rotate: 0,
    stretch: 0,
    depth: 80,
    modifier: 1.5,
    slideShadows: false,
  }}
  autoplay={{
    delay: 2500,
    disableOnInteraction: false,
  }}
  pagination={{ clickable: true }}
  className="mySwiper"
>

                {[img4, img3, img5, img6, img7, img8, img9, img10, img11, img12].map(
                  (imgSrc, index) => (
                    <SwiperSlide key={index}>
                      <div className="content">
                        <img
                          src={imgSrc}
                          alt={`Slide ${index + 1}`}
                          loading="lazy"
                        />
                      </div>
                    </SwiperSlide>
                  )
                )}
              </Swiper>
            </div>
          </div>

          <p className='business-section-description'>
            Experience the authentic and vibrant flavors of India, right at your doorstep. We offer a seamless way to enjoy our delicious Indian dishes. Whether you're looking to order for delivery, takeaway, or need catering for a special event, we have you covered!
          </p>

          <div className="button-container">
            <Link to="/order" className="business-button">Order Now</Link>
            <Link to="/takeaway" className="business-button">Takeaway</Link>
            <Link to="/Contactusform" className="business-button">Book Catering</Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Grababitenow;
